import { useLocalObservable } from 'mobx-react-lite';

import { useTranslation } from '@gem/modules/i18n';
import { popupsTasks } from '@gem/popups';

import Tasks from 'APP/Tasks';
import { CalendarType } from 'APP/model/calendar/calendar.types';

interface IEmailItemPresenter {
  onDisconnect(email: string): Promise<void>;
}

export const useEmailItemPresenter = (): IEmailItemPresenter => {
  const { t } = useTranslation();

  const presenter = useLocalObservable<IEmailItemPresenter>(() => ({
    async onDisconnect(email: string): Promise<void> {
      const canDisconnect = await popupsTasks.showConfirm({
        text: t('calendar_disconnect_confirm'),
        primaryText: t('calendar_disconnect'),
        secondaryText: t('calendar_cancel'),
      });

      if (!canDisconnect) {
        return;
      }

      await Tasks.calendar.logoutCalendar({
        account: {
          type: CalendarType.GOOGLE,
          providerEmail: email,
        },
      });
    },
  }));

  return presenter;
};
